import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  selectActors,
  selectSelectedElement,
  selectSelectedElementType,
  selectSelectedTake3D,
  setSelectedTake,
} from "../../app/slices/TrainingSlice";
import { SelectedTab, selectSelectedTab } from "../../app/slices/GlobalSlice";
import ActorAvatar from "../../components/actors/ActorAvatar";
import { PiKeyBlueScope } from "../../components/PiColorScope";
import { ActorState } from "../../models/ActorState";
import ActorStatePropertiesEditor from "../actor_state_properties_column/ActorStatePropertiesEditor";
import PiPopupWindowPreview from "../previews/components/PiPopupWindowPreview";

export default function ViewportActorStateWindow() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const selectedTab = useSelector(selectSelectedTab);
  const selectedElementType = useSelector(selectSelectedElementType);
  const selectedActorState = useSelector(selectSelectedElement) as
    | ActorState
    | undefined;
  const selectedTake = useSelector(selectSelectedTake3D);
  const actorPreset = useSelector(selectActors).find(
    (actor) => actor.id === selectedActorState?.actorId,
  );

  const isVisible = useMemo(() => {
    return (
      selectedTab === SelectedTab.Timeline &&
      selectedElementType === "actor" &&
      selectedActorState !== undefined &&
      selectedTake !== undefined
    );
  }, [selectedActorState, selectedElementType, selectedTab, selectedTake]);

  if (!isVisible || !selectedTake) return null;

  const actorName = actorPreset?.workingName ?? "Actor";

  // Design Studio actor-settings/redesign-attach-full-v3: avatar, name and the
  // take these settings belong to; no eyebrow label.
  const title = (
    <div className="viewport3d-actor-window__title-wrap">
      <ActorAvatar actor={actorPreset} size="36" />
      <div className="viewport3d-actor-window__title" title={actorName}>
        {actorName}
      </div>
      <span className="viewport3d-actor-window__scope">
        {String(t("actor_settings.in_take", { take: selectedTake.name }))}
      </span>
      {/* the same grey close button as PiDialog (interaction picker, other popups) */}
      <IconButton
        aria-label={String(t("actor_settings.close"))}
        className="viewport3d-actor-window__dialog-close"
        onClick={() => dispatch(setSelectedTake(selectedTake.id))}
      >
        <CloseIcon />
      </IconButton>
    </div>
  );

  return (
    <aside
      aria-label="viewport-actor-state-window"
      className="viewport3d-actor-window pi-scope-key-blue"
    >
      <PiKeyBlueScope>
        <PiPopupWindowPreview
          title={title}
          size="fit"
          body={
            <div className="viewport3d-actor-window__body">
              <ActorStatePropertiesEditor layout="tiles" />
            </div>
          }
        />
      </PiKeyBlueScope>
    </aside>
  );
}
